/*
 * BC: Renk tablosu davranışı (Basturk.co · basturk.co)
 * Kullanan: snippets/bc-renk-tablosu.liquid
 *
 * Görevleri:
 *  1) Seçili rengin metre kutusu — minimumla (varsayılan 3) başlar, 1'er metre
 *     artar, minimumun altına inmez; tutar canlı güncellenir.
 *  2) "Diğer renkler" — koleksiyon yoksa aynı kumaşın diğer renklerini SKU'nun
 *     "_" öncesinden bulup bağlantı satırı olarak ekler (Karzen'deki
 *     bc-color-swatches yöntemi: /collections/all/products.json taranır, sekme
 *     boyunca sessionStorage'da tutulur).
 *  3) "Tüm renkleri göster" aç/kapa.
 *  4) Sepete ekleme sayfadan çıkmadan (/cart/add.js) — ana buton seçili rengi,
 *     diğer renklerdeki "+" o rengi ekler (ilk dokunuş minimum metraj, sonra +1).
 *     Horizon'un CartLinesUpdateEvent'i yayılır → sepet ikonu ve çekmece kendini
 *     günceller; ana buton çekmeceyi açar ("add"), "+" açmaz ("update").
 *     Olay modülü yüklenemezse ana form normal gönderilir (sepet sayfasına gider).
 */
class BCRenkTablosu extends HTMLElement {
  static ONBELLEK = 'bc_serva_katalog_v2';

  connectedCallback() {
    if (!this.querySelector('[data-bc-form]')) {
      requestAnimationFrame(() => this.connectedCallback());
      return;
    }
    if (this.dataset.bcHazir) return;
    this.dataset.bcHazir = '1';

    this.min = parseInt(this.dataset.min, 10) || 3;
    this.input = this.querySelector('[data-bc-adet]');
    this.tutarEl = this.querySelector('[data-bc-tutar]');
    this.liste = this.querySelector('[data-bc-liste]');
    this.diger = this.querySelector('[data-bc-diger]');

    if (this.input) {
      const eksi = this.querySelector('[data-bc-eksi]');
      const arti = this.querySelector('[data-bc-arti]');
      arti?.addEventListener('click', () => this.#ayarla(this.#deger() + 1));
      eksi?.addEventListener('click', () => this.#ayarla(this.#deger() - 1));
      this.input.addEventListener('change', () => this.#ayarla(this.#deger()));
      this.#ayarla(this.#deger());
    }

    this.#dahaBagla(this.querySelector('[data-bc-daha]'));

    this.form = this.querySelector('[data-bc-form]');
    this.ekleBtn = this.querySelector('[data-bc-ekle]');
    this.hataEl = this.querySelector('[data-bc-hata]');
    this.form.addEventListener('submit', (e) => this.#anaEkle(e));
    this.liste?.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-bc-hizli]');
      if (btn) this.#hizliEkle(btn);
    });

    if (this.dataset.bcModel) this.#kardesleriYukle();
  }

  #deger() {
    return parseInt(this.input.value, 10) || 0;
  }

  #ayarla(yeni) {
    const v = Math.max(this.min, yeni);
    this.input.value = String(v);
    const eksi = this.querySelector('[data-bc-eksi]');
    if (eksi) eksi.disabled = v <= this.min;
    if (this.tutarEl) this.tutarEl.textContent = this.#para(v * (parseInt(this.input.dataset.fiyat, 10) || 0));
  }

  /* ---- Sepete ekleme ---- */

  static async olayModulu() {
    if (!BCRenkTablosu._olay) {
      BCRenkTablosu._olay = import('@shopify/events').then((m) => m.CartLinesUpdateEvent).catch(() => null);
    }
    return BCRenkTablosu._olay;
  }

  async #sepeteEkle(varyant, adet, cekmeceAcilsin) {
    const Olay = await BCRenkTablosu.olayModulu();
    if (!Olay) throw new Error('olay-modulu-yok');
    const kok = window.Shopify?.routes?.root || '/';
    const bolumler = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
    const govde = { items: [{ id: Number(varyant), quantity: adet }] };
    if (bolumler.length) {
      govde.sections = bolumler.join(',');
      govde.sections_url = window.location.pathname;
    }

    const ertelenen = Olay.createPromise();
    this.dispatchEvent(
      new Olay({
        action: cekmeceAcilsin ? 'add' : 'update',
        context: 'product',
        lines: [{ merchandiseId: String(varyant), quantity: adet }],
        promise: ertelenen.promise,
      })
    );

    let yanit;
    let sepet;
    try {
      yanit = await fetch(`${kok}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(govde),
      }).then((r) => r.json());
      sepet = await fetch(`${kok}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    } catch (hata) {
      ertelenen.reject(hata);
      throw new Error('Bağlantı hatası, tekrar deneyin');
    }
    ertelenen.resolve({
      cart: Olay.createCartFromAjaxResponse(sepet),
      detail: {
        items: sepet.items,
        source: 'bc-renk-tablosu',
        itemCount: adet,
        sections: yanit.sections,
        didError: !!yanit.status,
      },
    });
    if (yanit.status) throw new Error(yanit.description || yanit.message || 'Sepete eklenemedi');
    return sepet;
  }

  #hataGoster(metin) {
    if (!this.hataEl) return;
    this.hataEl.textContent = metin;
    this.hataEl.hidden = !metin;
  }

  async #anaEkle(e) {
    if (!this.input || !this.ekleBtn) return;
    e.preventDefault();
    const varyant = this.form.querySelector('input[name="items[0][id]"]')?.value;
    const metin = this.ekleBtn.textContent;
    this.ekleBtn.disabled = true;
    this.#hataGoster('');
    try {
      await this.#sepeteEkle(varyant, this.#deger(), true);
      this.ekleBtn.textContent = 'Sepete eklendi ✓';
      setTimeout(() => (this.ekleBtn.textContent = metin), 2000);
    } catch (hata) {
      if (hata.message === 'olay-modulu-yok') {
        this.form.submit();
        return;
      }
      this.#hataGoster(hata.message);
    } finally {
      this.ekleBtn.disabled = false;
    }
  }

  async #hizliEkle(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    const varyant = btn.dataset.bcHizli;
    const satir = btn.closest('[data-bc-satir]');
    const stok = satir?.querySelector('.bc-renk__stok');
    btn.setAttribute('aria-busy', 'true');
    try {
      // İlk ekleme minimum metraj; renk zaten sepetteyse 1'er metre.
      if (!this.sepetMiktar) {
        const sepet = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { Accept: 'application/json' },
        }).then((r) => r.json());
        this.sepetMiktar = new Map();
        sepet.items.forEach((i) => this.sepetMiktar.set(String(i.variant_id), (this.sepetMiktar.get(String(i.variant_id)) || 0) + i.quantity));
      }
      const onceki = this.sepetMiktar.get(varyant) || 0;
      const adet = onceki > 0 ? 1 : this.min;
      const sepet = await this.#sepeteEkle(varyant, adet, false);
      const toplam = sepet.items.filter((i) => String(i.variant_id) === varyant).reduce((t, i) => t + i.quantity, 0);
      this.sepetMiktar.set(varyant, toplam);
      if (stok) {
        stok.textContent = `Sepette ${toplam} m`;
        stok.classList.add('bc-renk__sepette');
      }
      btn.classList.add('bc-renk__hizli--tamam');
      btn.textContent = '✓';
      setTimeout(() => {
        btn.classList.remove('bc-renk__hizli--tamam');
        btn.textContent = '+';
      }, 1200);
    } catch (hata) {
      if (stok) stok.textContent = hata.message === 'olay-modulu-yok' ? 'Eklenemedi, sayfaya gidin' : hata.message;
    } finally {
      btn.removeAttribute('aria-busy');
    }
  }

  #para(kurus) {
    const bicim = this.dataset.bcParaBicim || '{{amount}}';
    const tutar = kurus / 100;
    const ayir = (sayi, ondalik, binlik, basamak) => {
      const [tam, kesir] = sayi.toFixed(basamak).split('.');
      const t = tam.replace(/\B(?=(\d{3})+(?!\d))/g, binlik);
      return kesir ? `${t}${ondalik}${kesir}` : t;
    };
    return bicim.replace(/\{\{\s*(\w+)\s*\}\}/, (_, tur) => {
      if (tur === 'amount_no_decimals') return ayir(tutar, '.', ',', 0);
      if (tur === 'amount_with_comma_separator') return ayir(tutar, ',', '.', 2);
      if (tur === 'amount_no_decimals_with_comma_separator') return ayir(tutar, ',', '.', 0);
      if (tur === 'amount_with_apostrophe_separator') return ayir(tutar, '.', "'", 2);
      return ayir(tutar, '.', ',', 2);
    });
  }

  #dahaBagla(btn) {
    if (!btn) return;
    btn.addEventListener('click', () => {
      const acik = btn.getAttribute('aria-expanded') === 'true';
      this.querySelectorAll('[data-bc-fazla]').forEach((satir) => {
        satir.classList.toggle('bc-renk__satir--gizli', acik);
      });
      btn.setAttribute('aria-expanded', String(!acik));
      const metin = btn.querySelector('[data-bc-daha-metin]');
      const toplam = this.liste?.querySelectorAll('[data-bc-satir]').length || 0;
      if (metin) metin.textContent = acik ? `Tüm renkleri göster (${toplam})` : 'Daha az göster';
    });
  }

  static katalog() {
    if (BCRenkTablosu._istek) return BCRenkTablosu._istek;
    try {
      const kayit = sessionStorage.getItem(BCRenkTablosu.ONBELLEK);
      if (kayit) return (BCRenkTablosu._istek = Promise.resolve(JSON.parse(kayit)));
    } catch {}
    const kurus = (f) => (f == null ? 0 : Math.round(parseFloat(f) * 100));
    const tum = [];
    const sayfa = (n) =>
      fetch(`/collections/all/products.json?limit=250&page=${n}`, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : { products: [] }))
        .then((veri) => {
          const urunler = veri?.products || [];
          urunler.forEach((u) => {
            const v = u.variants?.[0];
            if (!v || u.variants.length !== 1) return;
            tum.push({
              h: u.handle,
              t: u.title,
              s: v.sku || '',
              i: u.images?.[0]?.src || '',
              a: !!v.available,
              v: v.id,
              p: kurus(v.price),
              c: kurus(v.compare_at_price),
            });
          });
          return urunler.length === 250 && n < 40 ? sayfa(n + 1) : tum;
        });
    BCRenkTablosu._istek = sayfa(1).then((liste) => {
      try {
        sessionStorage.setItem(BCRenkTablosu.ONBELLEK, JSON.stringify(liste));
      } catch {}
      return liste;
    });
    return BCRenkTablosu._istek;
  }

  async #kardesleriYukle() {
    const model = this.dataset.bcModel;
    const benim = this.dataset.bcHandle;
    let liste;
    try {
      liste = await BCRenkTablosu.katalog();
    } catch {
      return;
    }
    const kod = (sku) => String(sku).split('_')[0].trim();
    const renkKodu = (sku) => String(sku).split('_').slice(1).join('_');
    const digerleri = liste.filter((u) => u.s && kod(u.s) === model && u.h !== benim);
    if (!digerleri.length || !this.liste) return;

    digerleri.sort((x, y) => {
      const a = renkKodu(x.s);
      const b = renkKodu(y.s);
      const na = parseInt(a, 10);
      const nb = parseInt(b, 10);
      if (!Number.isNaN(na) && !Number.isNaN(nb) && na !== nb) return na - nb;
      return a.localeCompare(b, 'tr');
    });

    let acik = parseInt(this.dataset.bcAcik, 10) || 5;
    // Gizlenecek tek satır için "Tüm renkleri göster" çıkmaz; hepsi açık.
    if (digerleri.length <= acik + 1) acik = digerleri.length;
    const satirlar = digerleri.map((u, i) => {
      const li = this.#satirKur(u);
      if (i >= acik) {
        li.setAttribute('data-bc-fazla', '');
        li.classList.add('bc-renk__satir--gizli');
      }
      return li;
    });
    this.liste.replaceChildren(...satirlar);

    const sayi = this.querySelector('[data-bc-sayi]');
    if (sayi) sayi.textContent = `(${satirlar.length})`;

    if (satirlar.length > acik && !this.querySelector('[data-bc-daha]')) {
      const btn = document.createElement('button');
      btn.className = 'bc-renk__daha';
      btn.type = 'button';
      btn.setAttribute('data-bc-daha', '');
      const metin = document.createElement('span');
      metin.setAttribute('data-bc-daha-metin', '');
      metin.textContent = `Tüm renkleri göster (${satirlar.length})`;
      const ok = document.createElement('span');
      ok.className = 'bc-renk__ok';
      ok.setAttribute('aria-hidden', 'true');
      ok.textContent = '⌄';
      btn.append(metin, ok);
      this.liste.after(btn);
      this.#dahaBagla(btn);
    }
    if (this.diger) this.diger.hidden = false;
  }

  /* snippets/bc-renk-satiri.liquid ile aynı markup — biri değişirse öteki de. */
  #satirKur(u) {
    const ad = u.t.includes(' — ') ? u.t.split(' — ').pop() : u.t;
    const li = document.createElement('li');
    li.className = 'bc-renk__satir' + (u.a ? '' : ' bc-renk__satir--tukendi');
    li.setAttribute('data-bc-satir', '');

    const link = document.createElement('a');
    link.className = 'bc-renk__link';
    link.href = `/products/${u.h}`;

    const gorsel = document.createElement('span');
    gorsel.className = 'bc-renk__gorsel';
    if (u.i) {
      const img = document.createElement('img');
      const ek = u.i.includes('?') ? '&' : '?';
      img.src = `${u.i}${ek}width=120`;
      img.srcset = `${u.i}${ek}width=60 60w, ${u.i}${ek}width=120 120w`;
      img.sizes = '52px';
      img.width = 120;
      img.height = 120;
      img.loading = 'lazy';
      img.alt = ad;
      gorsel.append(img);
    }

    const bilgi = document.createElement('span');
    bilgi.className = 'bc-renk__bilgi';
    const adEl = document.createElement('span');
    adEl.className = 'bc-renk__ad';
    const kodEl = document.createElement('span');
    kodEl.className = 'bc-renk__kod';
    kodEl.textContent = u.s;
    adEl.append(kodEl, document.createTextNode(ad));
    const stok = document.createElement('span');
    stok.className = 'bc-renk__stok';
    stok.textContent = u.a ? 'Stokta' : 'Tükendi';
    bilgi.append(adEl, stok);

    const fiyat = document.createElement('span');
    fiyat.className = 'bc-renk__fiyat';
    if (u.c > u.p) {
      const s = document.createElement('s');
      s.textContent = this.#para(u.c);
      fiyat.append(s);
    }
    const f = document.createElement('span');
    f.textContent = this.#para(u.p);
    fiyat.append(f);

    link.append(gorsel, bilgi, fiyat);
    li.append(link);
    if (u.a) {
      const btn = document.createElement('button');
      btn.className = 'bc-renk__hizli';
      btn.type = 'button';
      btn.dataset.bcHizli = String(u.v);
      btn.setAttribute('aria-label', `${ad} — sepete ekle`);
      btn.textContent = '+';
      li.append(btn);
    }
    return li;
  }
}

if (!customElements.get('bc-renk-tablosu')) {
  customElements.define('bc-renk-tablosu', BCRenkTablosu);
}
